import { searchAxios } from './searchAxios'
import { toDomainHttpClient } from './toDomainHttpClient'

// 검색 서버는 트래킹 이벤트명(mp_event_name)을 쿼리 파라미터로 받는다.
export const domainSearchHttpClient = toDomainHttpClient(searchAxios, { forwardMeta: true })
